import { DuplicateForm } from '../appointments'

function openInstantly (modal, openClass) {
  setTimeout(function () {
    modal.addClass(openClass);
  }, 100);
}

export function initModal(selector, html, isOpenInstantly = true) {
  const $modalWrapper = $(selector);

  $modalWrapper.html(html);

  const $modal = $modalWrapper.find('.modal');
  const $modalCloseButton = $modal.find('.modal__overlay, .modal__close');
  const $modalSubmitButton = $modal.find('.modal__button_submit');
  const openClass = 'modal--open';

  if (isOpenInstantly) openInstantly($modal, openClass)

  $modalCloseButton.on('click', function () {
    closeModal(selector)
  })
  $modalSubmitButton.on('click', function (event) {
    if (event.target.onclick && event.target.onclick.length) {
      event.originalEvent.preventDefault();
      return;
    }
    const form = $modal.find('form')[0];
    Rails.fire(form, 'submit');
  })
}

export function openModal (selector) {
  const $modalWrapper = $(selector);
  const $modal = $modalWrapper.find('.modal');
  const openClass = 'modal--open';

  $modal.addClass(openClass);
}

export function updateModal(selector, html) {
  const $modal = $(selector).find('.modal__body');

  $modal.html(html);
}

export function closeModal(selector) {
  const $modal = $(selector).find('.modal');
  DuplicateForm.closeFormVisibility();
  $modal.removeClass('modal--open');
}
